import { render, staticRenderFns } from "./TreatmentRecord.vue?vue&type=template&id=4d31fde0&scoped=true"
import script from "./TreatmentRecord.vue?vue&type=script&lang=js"
export * from "./TreatmentRecord.vue?vue&type=script&lang=js"
import style0 from "./TreatmentRecord.vue?vue&type=style&index=0&id=4d31fde0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d31fde0",
  null
  
)

export default component.exports